import Vertex from "./vertex";

import Geometry from "./geometry";

export default class Model {

    private edgeCount = 0;

    getEdgeCount(): any {
        return Math.max(this.edgeCount, 1);
    }
    getAllVertices(): { [id:string]: Vertex } {
        return this.vertices
    }
    getAllEdges(): { [id:string]: { [id:string]: Vertex } } {        
        return this.edges;
    }  
    private vertices: { [id:string]: Vertex };
    private edges: { [id:string]: { [id:string]: Vertex } };
    private geometry: { [id:string]: Geometry };
    private index: number;

    constructor() {
        this.vertices = {};
        this.edges = {};
        this.geometry = {};
        this.index = 0;
    }
    getVertices(): Vertex[] {
        return Object.values(this.vertices);
    }
    isEdge(cell: Vertex): any {
        return true;
    }
    
    getEdges(model: any, arg1: Vertex): { [id:string]: Vertex } {
        return this.edges[arg1.getId()];
    }

    add(arg1: Vertex): Vertex {        
        arg1.setId((this.index++).toString());
        this.edges[arg1.getId()] = {};
        this.vertices[arg1.getId()] = arg1;
        this.geometry[arg1.getId()] = new Geometry(5, 5, 0, 0);    
        return arg1;
    }
    setGeometry(arg0: Vertex, geo: Geometry): any {
        this.geometry[arg0.getId()] = geo;
    }
    isVertex(arg0: Vertex): boolean {
        return true;
    }

    endUpdate(): any {
        
    }
    getGeometry(vertex: Vertex): Geometry | null {
        return this.geometry[vertex.getId()]
    }
    beginUpdate(): any {
        
    }

    removeEdge(n1: Vertex, n2: Vertex): any {             
        delete this.edges[n1.getId()][n2.getId()];     
        delete this.edges[n2.getId()][n1.getId()];  
        this.edgeCount--; 
    }

    removeNode(n1: Vertex): any {               
        delete this.vertices[n1.getId()];
    }

    addEdge(n1: Vertex, n2: Vertex): any {       
        this.edgeCount++; 
        this.edges[n1.getId()][n2.getId()] = n2;
        this.edges[n2.getId()][n1.getId()] = n1;
        return true;
    }
}